import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M19 10.07c0-4.981-4.032-9.023-9-9.023s-9 4.042-9 9.022a9.025 9.025 0 007.2 8.842v-6.135H6.4V10.07h1.8V7.814a3.157 3.157 0 013.15-3.158h2.25v2.707h-1.8c-.495 0-.9.406-.9.902v1.804h2.7v2.707h-2.7v6.27c4.545-.45 8.1-4.294 8.1-8.977z"
        fill={props.color ?? "#353945"}
      />
    </svg>
  );
}

export default SvgComponent;
